module.exports = __webpack_public_path__ + "img/logo — копия.0206d184.png";